module.exports = __webpack_public_path__ + "static/media/anc19ru.9326b11f.pdf";